let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("dsiAd"), load("b8xTT")]).then(() => parcelRequire('iC69g'));